import { and } from '@lumapps/utils/function/predicate/and';
import type { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME } from '../../../components/blocks/PlayVideo';
import { PLAY_VIDEO } from '../../../constants';
import { createPlayVideo } from '../../../utils/createPlayVideo';

type ElementTypes = typeof PLAY_VIDEO;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    [PLAY_VIDEO]: {
        type: PLAY_VIDEO,
        test: and(matchAttribute('className', new RegExp(CLASSNAME)), matchAttribute('dataVideoId', /./)),
        transform: ({ properties }: any) => {
            const { dataVideoId, dataVideoTitle } = properties;

            return createPlayVideo({ id: dataVideoId, title: dataVideoTitle, url: `/play-video/${dataVideoId}` });
        },
    },
};
